export function getDeposit(data) {
    let { getDepositRequest, getDepositError, getDepositResult } = this.props

    this.doAction(
        this.WEB_REQUEST_URL + 'app/deposit/get',
        this.createBundle('app/deposit/get', { deposit: data }, this.GET, getDepositRequest, getDepositResult, getDepositError)
    )
}
